import { IRevenueAgencyAllLang } from '../../../types/lang'
import { revenueAgencyCrudModalLang } from './revenueAgencyCrudModal'
import { revenueAgencyPageLang } from './revenueAgencyPage'
import { revenueAgencyListTableLang } from './revenueAgencyListTable'

export const revenueAgencyAllLang: IRevenueAgencyAllLang = {
	...revenueAgencyPageLang,
	...revenueAgencyCrudModalLang,
	...revenueAgencyListTableLang
}